import http from 'hub-http/clients/apiClient';
import { userInfoSync } from 'hub-http/userInfo';
import { createRpcClientV2 } from 'rpc-client-utils';
import { BULK_RPC_MAP, SINGLE_RPC_MAP } from './rpcMethods';
import { getContentSecurityStateRpc } from '../../__generated__/chirp/com/hubspot/security/state/rpc/SecurityStateAppRpc';
import reviewState from '../constants/reviewState';
import { SECURITY_STATE_GATE } from '../constants/gates';
const TAG_CODE_TO_REVIEW_STATE = {
  CONTENT_FLAGGED_FOR_REVIEW: reviewState.IN_REVIEW,
  CONTENT_REVIEWED_VIOLATING: reviewState.BLOCKED,
  CONTENT_REVIEWED_OK: reviewState.OK
};
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const getSecurityStateForContent = (entityId, contentType) => {
  return rpcClient.call(getContentSecurityStateRpc, {
    request: {
      entityId,
      contentType
    }
  }).then(({
    entries
  }) => {
    if (!entries || entries.length === 0) {
      return {
        reviewState: reviewState.NO_REVIEW
      };
    }
    const relevantEntry = entries.find(entry => entry.tagCode in TAG_CODE_TO_REVIEW_STATE);
    return {
      reviewState: relevantEntry ? TAG_CODE_TO_REVIEW_STATE[relevantEntry.tagCode] : reviewState.NO_REVIEW
    };
  });
};
export const getSuspensionStatus = (contentId, keyWord) => {
  if (!SINGLE_RPC_MAP[keyWord]) {
    return Promise.resolve({});
  }
  return rpcClient.call(SINGLE_RPC_MAP[keyWord], {
    request: {
      contentId: String(contentId)
    }
  });
};
export const getModerationStatus = (contentId, keyWord, campaignId) => {
  const {
    gates
  } = userInfoSync();
  if (keyWord === 'email' && campaignId !== undefined && gates.includes(SECURITY_STATE_GATE)) {
    return getSecurityStateForContent(`${campaignId}-${contentId}`, 'EMAIL');
  }
  if (keyWord === 'form' && gates.includes(SECURITY_STATE_GATE)) {
    return getSecurityStateForContent(String(contentId), 'FORM');
  }
  if (keyWord === 'webpage' && gates.includes(SECURITY_STATE_GATE)) {
    return getSecurityStateForContent(String(contentId), 'CMS_PAGE');
  }
  return getSuspensionStatus(contentId, keyWord);
};
export const getBulkSuspensionStatus = (contentIds, keyWord) => {
  if (!BULK_RPC_MAP[keyWord]) {
    return Promise.resolve({});
  }
  return rpcClient.call(BULK_RPC_MAP[keyWord], {
    request: {
      contentIds: contentIds.map(String)
    }
  }).then(response => response.moderationStatuses);
};
export const getHubContentReviewStatus = contentId => {
  console.log(contentId);
  return Promise.resolve({
    reviewState: 'IN_REVIEW',
    portalLevel: 'ENTERPRISE',
    slaCopyType: 'NON_CORE'
  });
};